import { LOCAL_STORAGE_PREFIX } from '../constants';

export const get = (key: string) => {
  const data = localStorage.getItem(`${LOCAL_STORAGE_PREFIX}.${key}`);
  return data ? JSON.parse(data) : undefined;
};

export const set = (key: string, value: unknown) =>
  localStorage.setItem(`${LOCAL_STORAGE_PREFIX}.${key}`, JSON.stringify(value));
